import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useEramanProductReview } from "../Contents.hook";
import { fields } from "../constants";

export const ProductReview = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useEramanProductReview();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    } else {
      refetchEditData();
    }
  }, [query.get("id")]);

  const ProductReviewFormConfig: FormConfig = {
    initialValues: {
      title: dataById ? dataById.payload.title : editData ? editData?.[0]?.title : "",
      field_heading_text: dataById
        ? dataById.payload.field_heading_text
        : editData
          ? editData?.[0]?.field_heading_text
          : "",

      field_review_title: dataById
        ? dataById.payload.field_review_title
        : editData
          ? editData?.[0]?.field_review_title
          : "",

      field_attachments: dataById
        ? dataById.payload.field_attachments
        : editData
          ? editData?.[0]?.field_attachments
          : "",

      field_browse_files: dataById
        ? dataById.payload.field_browse_files
        : editData
          ? editData?.[0]?.field_browse_files
          : "",

      field_file_extensions_allowed: dataById
        ? dataById.payload.field_file_extensions_allowed
        : editData
          ? editData?.[0]?.field_file_extensions_allowed
          : "",

      field_description: dataById
        ? dataById.payload.field_description
        : editData
          ? editData?.[0]?.field_description
          : "",

      field_submit_button: dataById
        ? dataById.payload.field_submit_button
        : editData
          ? editData?.[0]?.field_submit_button
          : "",
    },
    fields: fields.eramanProductReview,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["field_icon_image", "field_icon_facebook", "field_eye_icon"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    let descKeys: any = ["field_password_conditions_zh", "field_password_conditions_ms", "field_password_conditions"];
    for (const key of descKeys) {
      try {
        data[key] = {
          value: data[key] || "",
          format: "full_html",
        };
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Contents",
      subModule: `eramanProductReview`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
      isLoading={isLoadingData || drilldownLoading}
      config={ProductReviewFormConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${eramanHost}/api/product-review-page-update-api-list/${editData?.[0]?.id || dataById?.payload?.id}`,
          "UPDATE",
          "PATCH",
          buttonValue == "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
    />
  );
};
